module.exports = __webpack_public_path__ + "static/media/lucky-orange-icon.4106dcb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/lucky-orange-icon.jpg
// module id = 2747
// module chunks = 0